/**------------- Contacts Content constants -------------**/

/*  General  */
export const CONTACTS_BUTTONS_CONTAINER_CLASS_NAME =
	"contact-buttons-container";

/*  Title  */
export const CONTACTS_TITLE = "Siamo qui per te.";
